import Component from "../component.abstract"

interface EventTrack {
    event: string,
    trigger: string,
    ecommerce: Ecommerce,
    totalCount: string,
    types : string[],
    autoSearch: boolean
}

interface Ecommerce {
    currencyCode: string,
    impressions: any[]
}

export default class TrackOffer extends Component {
    nbOffers: string;
    constructor(
        private props: unknown,
        element:HTMLElement
    ) {
        super(props, element)
    }

    mounted():void {
        //do nothing
    }

    enableTracking(data: any, tracker: any):void {
        if(data) {
            setTimeout(()=>{
                const ev: EventTrack = {
                    event: "impressionLoad",
                    trigger : "init",
                    ecommerce:{
                        currencyCode : "EUR",
                        impressions : []
                    },
                    totalCount : this.nbOffers,
                    types : ["gtm"],
                    autoSearch: true
                }
                const fors = this.element.querySelectorAll("[data-click]");
                for (let i = 0; i < fors.length; i++) {
                    const off = fors[i];
                    const elt = JSON.parse(off.getAttribute("data-click"));
                    ev.ecommerce.impressions.push(elt);
                }
                 tracker.addEvents([ev], this);
            },1000)
        }
    }

}